'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _regulatorAddForm = require('./regulator-add-form.component');

var _regulatorAddForm2 = _interopRequireDefault(_regulatorAddForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.dashboard.regulator-add-form', []).component('regulatorAddForm', _regulatorAddForm2.default).name;


// WEBPACK FOOTER //
// ./components/app/admin/regulator/regulator-add-form/regulator-add-form.module.js